import { render } from "./JobQueuesStatisticsTable.vue?vue&type=template&id=df80e290&scoped=true"
import script from "./JobQueuesStatisticsTable.vue?vue&type=script&lang=js"
export * from "./JobQueuesStatisticsTable.vue?vue&type=script&lang=js"

import "./JobQueuesStatisticsTable.vue?vue&type=style&index=0&id=df80e290&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df80e290"]])

export default __exports__